import type React from "react";
import { ViewId } from "@msidentity/SISU/constants";
import { useRedirect } from "@msidentity/SISU/hooks/use-redirect";
import { replaceTokens } from "@msidentity/SISU/utilities/strings-helper";
import {
  usernameRecoveryCollectProofViewStringsFabric as viewStrings,
  usernameRecoveryGenericStringsFabric as genericStrings,
} from "../../../fabric/username-recovery-strings-fabric";
import { useSendOtt } from "../../../model/hooks/use-send-ott";
import UsernameRecoveryConfig from "../../../username-recovery-config";
import { useUsernameRecoveryContext } from "../../../username-recovery-context";

/**
 * @returns callback functions for the primary and secondary buttons
 */
export const usePhoneSpeedbump = () => {
  const { cancelUrl, allowProofBasedSignIn } = UsernameRecoveryConfig.instance;
  const {
    viewState: { usernameVal, usernameDisplay, phoneCountryState, usernameType },
  } = useUsernameRecoveryContext();
  const redirect = useRedirect();

  const callSendOtt = useSendOtt({
    viewId: ViewId.UsernameRecoveryPhoneSpeedbump,
    memberNameType: usernameType,
    phoneCountry: phoneCountryState,
    proofId: usernameVal,
  });
  const onSubmitHandler = (event: React.SyntheticEvent) => {
    event.preventDefault();

    callSendOtt();
  };

  const onBackHandler = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    redirect(cancelUrl);
  };

  let { title } = genericStrings;
  let descriptionString = viewStrings.phonePrefillDescription;

  if (allowProofBasedSignIn) {
    title = viewStrings.verifyItsYouTitle;
    descriptionString = viewStrings.phonePrefillSendSmsDescription;
  }

  const description = replaceTokens(descriptionString, usernameDisplay);

  return { onSubmitHandler, onBackHandler, description, title };
};
